/**
 * 友盟埋点的配置文件
 * */
export const uMengConfig = {
  'wEnterprise_consult_click': {
    name: 'wEnterprise_consult_click',
    desc: '网维助手企业账号点击咨询'
  }
}
